import {
  csvDataExportReportMiscellaneous,
  MiscellaneousOptions,
} from '../../reportsTypes';
import { SelectType } from '@ais-ui/ui-core';

export const parseCsvMiscellaneousDataFields = (
  inputValues: string[]
): SelectType[] => {
  const dataFieldOptions = csvDataExportReportMiscellaneous.dataFields.options;

  const chosenDataFields: SelectType[] = [];
  if (!dataFieldOptions) {
    return chosenDataFields;
  }

  dataFieldOptions.forEach((dataFieldOption) => {
    if (inputValues.includes(dataFieldOption.value)) {
      chosenDataFields.push({
        label: dataFieldOption.label,
        value: dataFieldOption.value,
      });
    }
  });

  return chosenDataFields;
};

export const parseCsvMiscellaneousMessageTypes = (
  inputValues: string[] | null
) => {
  const messageTypeOptions =
    csvDataExportReportMiscellaneous.messageType.options;

  if (!messageTypeOptions) {
    return;
  }

  const chosenMessageTypes: SelectType[] = [];
  messageTypeOptions.forEach((messageTypeOption) => {
    if (inputValues && inputValues.includes(messageTypeOption.value)) {
      chosenMessageTypes.push({
        label: messageTypeOption.label,
        value: messageTypeOption.value,
      });
    }
  });

  return messageTypeOptions;
};
